export const PasswordRequirements = [
  {
    id: '1',
    text: 'passwordLengthRestriction',
    state: 'length',
  },
  {
    id: '2',
    text: 'containsCapitalSmallLetter',
    state: 'capitalSmallLetters',
  },
  {
    id: '3',
    text: 'containsNumber',
    state: 'numbers',
  },
  {
    id: '4',
    text: 'containsSpecialCharacter',
    state: 'specialCharacters',
  },
];
